import { Button, Chip, Popover } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { PayerInfoIcon } from './schedule-icon';

type Props = {};

type TypePayerLegend = {
  id: number;
  color: string;
  bgColor: string;
  label: string;
};

const payerLegend: TypePayerLegend[] = [
  {
    id: 1,
    color: '#76CE82',
    bgColor: 'rgba(118, 206, 130, 0.15)',
    label: 'Part A',
  },
  {
    id: 2,
    color: '#FFC700',
    bgColor: ' rgba(255, 199, 0, 0.15)',
    label: 'Part B',
  },
  {
    id: 3,
    color: '#FF7262',
    bgColor: 'rgba(255, 114, 98, 0.15)',
    label: 'Medicaid',
  },
  {
    id: 4,
    color: '#0A9ECC',
    bgColor: 'rgba(10, 158, 204, 0.15)',
    label: 'Other',
  },
];

const PayerColorLegend = (props: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Button
        aria-describedby={id}
        variant="text"
        onClick={handleClick}
        endIcon={<PayerInfoIcon />}
      >
        Payer Color Guide
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box>
          {payerLegend.map((payerColor: TypePayerLegend) => (
            <Chip
              variant="outlined"
              size="small"
              key={payerColor.id}
              sx={{
                display: 'flex',
                width: '150px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#E5E7EB',
                color: '#111927',
                borderRadius: '20px',
                borderBottom: `2px solid ${payerColor.color}`,
                background: payerColor.bgColor,
                fontFamily: 'Inter ',
                fontSize: '12px ',
                textWrap: 'nowrap',
                zIndex: 10,
                margin: '10px 10px',
              }}
              label={payerColor.label}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default PayerColorLegend;
